'use client'

import { clientPage } from '../../_lib/clientPage'

export default clientPage(() =>
  import('@/components/views/accountManagement/registerWizard/RegisterWizardHomeView').then(
    (m) => ({
      default: m.RegisterWizardHomeView,
    })
  )
)
